export const queryKeys = {
  ARREARS_COMPONENTS_LIST: 'ARREARS_COMPONENTS_LIST',
  FETCH_ARREARS: 'FETCH_ARREARS',
  BULK_PREVIEW_ARREARS: 'BULK_PREVIEW_ARREARS',
  BULK_DELETE_ARREARS: 'BULK_DELETE_ARREARS',
  SAVE_ARREARS: 'SAVE_ARREARS',
  GET_USER_PAYROLL_MONTHS: 'GET_USER_PAYROLL_MONTHS'
};
